import { apiClient } from '@/lib/api/api-client'
import { Floor } from '../types/floor'

export const floorApi = {
  getFloor: (buildingId: string, id: string) => {
    return apiClient.get<Floor>(`building/${buildingId}/floors/${id}`)
  },

  createFloor: (buildingId: string, payload: any) => {
    return apiClient.post<Floor>(`building/${buildingId}/floors`, payload)
  },

  updateFloor: (buildingId: string, floorId: string, payload: any) => {
    return apiClient.put<Floor>(`building/${buildingId}/floors/${floorId}`, payload)
  },

  deleteFloor: (buildingId: string, floorId: string) => {
    return apiClient.delete<void>(`building/${buildingId}/floors/${floorId}`)
  },
}
